import React from "react";
import { Select } from "antd";

export const FilterNameSelector = ({
    selectedFieldName,
    setSelectedFieldName,
    metaData,
    mode,
}) => {
    const filteredMetaData = metaData?.filter((item) => {
        return item.type === 'date' || (item.values && item.values.length > 0);
    });
    return (
        <Select
            mode={mode}
            allowClear
            showSearch
            style={{ width: 150 }}
            placeholder="Select Filter Name"
            value={selectedFieldName}
            onChange={(value) =>
                mode
                    ? setSelectedFieldName(value)
                    : setSelectedFieldName([value])
            }
            options={filteredMetaData}
            fieldNames={{ label: "name", value: "name" }}
            size="small"
        />
    );
};
